import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight, faWindowRestore, faUnlink, faWater, faDotCircle, faCaretDown, faCaretUp, faFileExport, faTimes, faHistory, faCog, faCogs, faFileUpload, faEdit, faPencilAlt, faTrash, faBars, faExclamationCircle,
  faAngleDown, faEllipsisH, faEllipsisV, faCalendar, faInfoCircle,
  faCloudUploadAlt, faQuestion, faPlus, faPlusCircle, faEye, faEyeSlash,
  faLink, faAlignLeft, faAlignJustify, faUsers, faLock, faUnlock, faStar, faFile, faCheckCircle, faSpinner, faEraser, faTrophy, faChessKnight, faWindowMaximize, faClone, faQuestionCircle, faDharmachakra, faArrowRight } from '@fortawesome/free-solid-svg-icons'

import { faCloudsmith, faConnectdevelop } from '@fortawesome/free-brands-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faChevronRight, faUnlink, faClone, faWindowRestore, faWater, faDharmachakra, faArrowRight, faDotCircle, faCaretDown, faChessKnight, faWindowMaximize, faTrophy, faCaretUp, faFileExport, faConnectdevelop, faCloudsmith, faTimes, faHistory, faCog, faCogs, faFileUpload, faEdit, faPencilAlt, faTrash, faEraser, faBars, faExclamationCircle, faCheckCircle, faSpinner, faFile, faAngleDown, faEllipsisH, faEllipsisV, faCalendar, faLock, faUnlock, faStar, faUsers, faInfoCircle, faCloudUploadAlt, faQuestion, faPlus, faPlusCircle, faEye, faEyeSlash, faLink, faAlignLeft, faAlignJustify, faQuestionCircle)

Vue.component('font-awesome-icon', FontAwesomeIcon)



// WEBPACK FOOTER //
// ./src/plugins/ui/font-awesome.js